import PropTypes from 'prop-types';
import sum from 'lodash/sum';
// @mui
import Card from '@mui/material/Card';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Unstable_Grid2';
import CardHeader from '@mui/material/CardHeader';
import Typography from '@mui/material/Typography';
// routes
// import { paths } from 'src/routes/paths';
// components
import Iconify from 'src/components/iconify';
// import { RouterLink } from 'src/routes/components';
import EmptyContent from 'src/components/empty-content';
//
import { useNavigate, useSearchParams } from 'react-router-dom';
import { paths } from 'src/routes/paths';
import CheckoutSummary from './checkout-summary';
import CheckoutCartProductList from './checkout-cart-product-list';

// ----------------------------------------------------------------------

export default function CheckoutCart({
  checkout,
  onNextStep,
  onDeleteCart,
  onApplyDiscount,
  onIncreaseQuantity,
  onDecreaseQuantity,
  layoutVariant,
}) {
  const { cart, total, discount, subTotal } = checkout;

  const totalItems = sum(cart.map((item) => item.quantity));

  const empty = !cart.length;

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const listOnly = layoutVariant === 'orderingV2ListOnly';

  const continueShoppingPath = `${paths.dashboard.v2.product.root}?${searchParams.toString()}`;

  const listColumn = (
    <>
      <Card sx={{ mb: 3 }}>
        <CardHeader
          title={
            <Typography variant="h6">
              Cart
              <Typography component="span" sx={{ color: 'text.secondary' }}>
                &nbsp;({totalItems} item)
              </Typography>
            </Typography>
          }
          sx={{ mb: 3 }}
        />

        {!empty ? (
          <CheckoutCartProductList
            products={cart}
            onDelete={onDeleteCart}
            onIncreaseQuantity={onIncreaseQuantity}
            onDecreaseQuantity={onDecreaseQuantity}
          />
        ) : (
          <EmptyContent
            title="Cart is Empty!"
            description="Look like you have no items in your shopping cart."
            imgUrl="/assets/icons/empty/ic_cart.svg"
            sx={{ pt: 5, pb: 10 }}
          />
        )}
      </Card>

      <Button
        onClick={() => {
          if (listOnly) {
            navigate(continueShoppingPath);
          } else {
            navigate(-2);
          }
        }}
        color="inherit"
        startIcon={<Iconify icon="eva:arrow-ios-back-fill" />}
      >
        Continue Shopping
      </Button>
    </>
  );

  if (listOnly) {
    return listColumn;
  }

  return (
    <Grid container spacing={3}>
      <Grid xs={12} md={8}>
        {listColumn}
      </Grid>

      <Grid xs={12} md={4}>
        <CheckoutSummary
          enableDiscount
          total={total}
          discount={discount}
          subTotal={subTotal}
          onApplyDiscount={onApplyDiscount}
        />

        <Button
          fullWidth
          size="large"
          type="submit"
          variant="contained"
          color='primary'
          disabled={!cart.length}
          onClick={onNextStep}
        >
          Check Out
        </Button>
      </Grid>
    </Grid>
  );
}

CheckoutCart.propTypes = {
  checkout: PropTypes.object,
  onNextStep: PropTypes.func,
  onDeleteCart: PropTypes.func,
  onApplyDiscount: PropTypes.func,
  onDecreaseQuantity: PropTypes.func,
  onIncreaseQuantity: PropTypes.func,
  layoutVariant: PropTypes.oneOf(['orderingV2ListOnly']),
};
